import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import PollResults from './components/PollResults';
import Home from './components/Home';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import PollVote from './components/PollVote';
import Terms from './components/Terms';
import Profile from './components/Profile';
import MailingConsent from './components/MailingConsent';
import Unsubscribe from './components/Unsubscribe';
import Help from './components/Help';
import QaParticipant from './components/qa/QaParticipant';
import QaHost from './components/qa/QaHost';
import QaSessions from './components/qa/QaSessions';
import QaScreen from './components/qa/QaScreen';
import Presentations from './components/presentations/Presentations';
import SharePage from './components/presentations/SharePage';
import PresentationDownload from './components/presentations/PresentationDownload';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/vote/:pollId" element={<PollVote />} />
          <Route path="/poll/:pollId" element={<PollResults />} />
          <Route path="/embed/:pollId" element={<PollResults embed />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/mailing-consent" element={<MailingConsent />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/help" element={<Help />} />
          <Route path="/qa" element={<QaSessions />} />
          <Route path="/qa/:sessionRef" element={<QaParticipant />} />
          <Route path="/qa/:sessionRef/screen" element={<QaScreen />} />
          <Route path="/qa-host/:sessionId" element={<QaHost />} />
          <Route path="/my-presentations" element={<Presentations />} />
          <Route path="/share/:kind/:ref" element={<SharePage />} />
          <Route path="/presentation/:token" element={<PresentationDownload />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

